const ChartLoader = () => (
  <div className="h-[220px] animate-pulse rounded bg-gray-100 md:h-[350px]" />
)
export default ChartLoader
